import {useState, useCallback, forwardRef} from 'react'
import { parsePhoneNumber, AsYouType } from 'libphonenumber-js'
import TextField from '@mui/material/TextField'

const helperText = `If outside the US, use the international format starting with the country code e.g. +381`



const FormikPhoneNumberField = forwardRef(({
  field: { name, value },
  form: { touched, errors, setFieldValue, setFieldError },
  label = 'Phone Number',
  variant = 'filled',
  placeholder = '(718) 867-5309',
  ...props
}, ref) => {

  const [countryCode, setCountryCode] = useState('US')
  const errorMsg = errors[name]
  const showError = Boolean(touched[name] && errorMsg)



  const handleChange = useCallback(
    (e) => {
      let input = e.target.value || ''

      // prevent orphan '(' on US input
      if (input.includes('(') && !input.includes(')')) {
        input = input.replace('(', '')
      }

      // pick formatter based on leading '+'
      const asYouType = input.startsWith('+')
        ? new AsYouType()
        : new AsYouType('US')

      const formatted = asYouType.input(input)
      setFieldValue(name, formatted)
      setCountryCode(asYouType.getCountry() || 'US')
    },
    [name, setFieldValue]
  )


  const handleBlur = useCallback(
    (e) => {
      const input = e.target.value
      if (!input) return

      try {
        const parsed = parsePhoneNumber(input, countryCode)

        if (parsed.isPossible()) {
          const formatted = parsed.country === 'US'
            ? parsed.formatNational()
            : parsed.formatInternational()
          setFieldValue(name, formatted)
        } else {
          setFieldError(name, 'Invalid phone number')
        }
      } catch {
        setFieldError(name, 'Invalid phone number')
      }
    },
    [name, countryCode, setFieldValue, setFieldError]
  )



  return (
    <TextField
      name={name}
      label={label}
      variant={variant}
      placeholder={placeholder}
      value={value || ''}
      fullWidth
      error={showError}
      helperText={showError ? errorMsg : helperText}
      onChange={handleChange}
      onBlur={handleBlur}
      {...props}
    />
  )
})

export default FormikPhoneNumberField



